import {
  BulkCreateFundClassTagEmailRequest,
  BulkCreateFundClassTagEmailSuccessPayload,
  BulkDeleteFundClassTagEmailRequest,
  BulkDeleteFundClassTagEmailSuccessPayload,
  ClassificationTagBankRelationship,
  CreateBankFundCompanyPlatformMappingRequest,
  CreateBankFundCompanyPlatformMappingSuccessPayload,
  CreateClassificationTagBankRelationshipRequest,
  CreateClassificationTagBankRelationshipSuccessPayload,
  CreateClassificationTagDealNameHedgeRequest,
  CreateClassificationTagDealNameHedgeSuccessPayload,
  CreateClassificationTagLegalEntityRequest,
  CreateClassificationTagLegalEntitySuccessPayload,
  CreateFundClassTagEmailRequest,
  CreateFundClassTagEmailSuccessPayload,
  CreateFundCompanyRequest,
  CreateFundCompanySuccessPayload,
  CreateFundLevelTradePricingRequest,
  CreateFundLevelTradePricingSuccessPayload,
  CreateUserAuthorizationRequest,
  CreateUserAuthorizationSuccessPayload,
  CreateUserInitiatorRequest,
  CreateUserInitiatorSuccessPayload,
  CreateBidCriteriaRequest,
  CreateBidCriteriaSuccessPayload,
  CreateExecutionLedgerRequest,
  CreateExecutionLedgerSuccessPayload,
  CreateFixReferenceRequest,
  CreateFixReferenceSuccessPayload,
  CreateFixSessionRequest,
  CreateFixSessionSuccessPayload,
  CreateWorkflowFilteringPayload,
  DeleteBankFundCompanyPlatformMappingResponse,
  DeleteClassificationTagBankRelationshipResponse,
  GetAllFundCompaniesSuccessPayload,
  GetAllTransactionPlatformsSuccessPayload,
  GetAllUsersSuccessPayload,
  GetBankFundCompanyPlatformMappingSuccessPayload,
  GetBidCriteriaSuccessPayload,
  GetClassificationTagDealNameHedgesSuccessPayload,
  GetClassificationTagLegalEntitiesSuccessPayload,
  GetClassificationTagsBankRelationshipsSuccessPayload,
  GetExecutionLedgerSuccessPayload,
  GetFixReferencesSuccessPayload,
  GetFixSessionsSuccessPayload,
  GetFundClassTagEmailsSuccessPayload,
  GetFundLevelTradePricingsSuccessPayload,
  GetUserAuthorizationsSuccessPayload,
  GetUserInitiatorsSuccessPayload,
  GetWorkflowComapnyFiltersResponse,
  MapEmailToMultipleTagsRequest,
  MapEmailToMultipleTagsSuccessPayload,
  UpdateBankFundCompanyPlatformMappingRequest,
  UpdateBankFundCompanyPlatformMappingSuccessPayload,
  UpdateBidCriteriaRequest,
  UpdateBidCriteriaSuccessPayload,
  UpdateClassificationTagBankRelationshipRequest,
  UpdateClassificationTagDealNameHedgeRequest,
  UpdateClassificationTagDealNameHedgeSuccessPayload,
  UpdateClassificationTagLegalEntityRequest,
  UpdateClassificationTagLegalEntitySuccessPayload,
  UpdateExecutionLedgerRequest,
  UpdateExecutionLedgerSuccessPayload,
  UpdateFixReferenceRequest,
  UpdateFixReferenceSuccessPayload,
  UpdateFixSessionRequest,
  UpdateFixSessionSuccessPayload,
  UpdateFundClassTagEmailRequest,
  UpdateFundClassTagEmailSuccessPayload,
  UpdateFundCompanyRequest,
  UpdateFundCompanySuccessPayload,
  UpdateFundLevelTradePricingRequest,
  UpdateFundLevelTradePricingSuccessPayload,
  UpdateUserAuthorizationRequest,
  UpdateUserAuthorizationSuccessPayload,
  UpdateUserInitiatorRequest,
  UpdateUserInitiatorSuccessPayload,
  BulkCreateTradeRequestEmailRecipientRequest,
  BulkCreateTradeRequestEmailRecipientSuccessPayload,
  BulkDeleteTradeRequestEmailRecipientRequest,
  BulkDeleteTradeRequestEmailRecipientSuccessPayload,
  CreateTradeRequestEmailRecipientRequest,
  CreateTradeRequestEmailRecipientSuccessPayload,
  GetTradeRequestEmailRecipientsSuccessPayload,
  UpdateTradeRequestEmailRecipientRequest,
  UpdateTradeRequestEmailRecipientSuccessPayload,
} from '@/pages/FundLevelAdmin/types';

import { createAsyncAction } from 'typesafe-actions';

//  -------------------------------
//  Fund Module Aactions  / V2 Fund Level admin Page
//  ------------------------------- Good Stuffff

export const getClassificationTagsBankRelationships = createAsyncAction(
  'fundModule/getClassificationTagsBankRelationships/request',
  'fundModule/getClassificationTagsBankRelationships/success',
  'fundModule/getClassificationTagsBankRelationships/failure',
)<undefined, GetClassificationTagsBankRelationshipsSuccessPayload, undefined>();

export const getBankFundCompanyPlatformMapping = createAsyncAction(
  'fundModule/getBankFundCompanyPlatformMapping/request',
  'fundModule/getBankFundCompanyPlatformMapping/success',
  'fundModule/getBankFundCompanyPlatformMapping/failure',
)<undefined, GetBankFundCompanyPlatformMappingSuccessPayload, undefined>();

export const getAllTransactionPlatforms = createAsyncAction(
  'fundModule/getAllTransactionPlatforms/request',
  'fundModule/getAllTransactionPlatforms/success',
  'fundModule/getAllTransactionPlatforms/failure',
)<undefined, GetAllTransactionPlatformsSuccessPayload, undefined>();

export const getAllFundCompanies = createAsyncAction(
  'fundModule/getAllFundCompanies/request',
  'fundModule/getAllFundCompanies/success',
  'fundModule/getAllFundCompanies/failure',
)<undefined, GetAllFundCompaniesSuccessPayload, undefined>();

export const createFundCompany = createAsyncAction(
  'fundModule/createFundCompany/request',
  'fundModule/createFundCompany/success',
  'fundModule/createFundCompany/failure',
)<CreateFundCompanyRequest, CreateFundCompanySuccessPayload, undefined>();

export const createClassificationTagBankRelationship = createAsyncAction(
  'fundModule/createClassificationTagBankRelationship/request',
  'fundModule/createClassificationTagBankRelationship/success',
  'fundModule/createClassificationTagBankRelationship/failure',
)<
  CreateClassificationTagBankRelationshipRequest,
  CreateClassificationTagBankRelationshipSuccessPayload,
  undefined
>();

export const createBankFundCompanyPlatformMapping = createAsyncAction(
  'fundModule/createBankFundCompanyPlatformMapping/request',
  'fundModule/createBankFundCompanyPlatformMapping/success',
  'fundModule/createBankFundCompanyPlatformMapping/failure',
)<
  CreateBankFundCompanyPlatformMappingRequest,
  CreateBankFundCompanyPlatformMappingSuccessPayload,
  undefined
>();

export const updateClassificationTagBankRelationship = createAsyncAction(
  'fundModule/updateClassificationTagBankRelationship/request',
  'fundModule/updateClassificationTagBankRelationship/success',
  'fundModule/updateClassificationTagBankRelationship/failure',
)<
  UpdateClassificationTagBankRelationshipRequest,
  ClassificationTagBankRelationship,
  undefined
>();

export const updateBankFundCompanyPlatformMapping = createAsyncAction(
  'fundModule/updateBankFundCompanyPlatformMapping/request',
  'fundModule/updateBankFundCompanyPlatformMapping/success',
  'fundModule/updateBankFundCompanyPlatformMapping/failure',
)<
  UpdateBankFundCompanyPlatformMappingRequest,
  UpdateBankFundCompanyPlatformMappingSuccessPayload,
  undefined
>();

export const updateFundCompany = createAsyncAction(
  'fundModule/updateFundCompany/request',
  'fundModule/updateFundCompany/success',
  'fundModule/updateFundCompany/failure',
)<UpdateFundCompanyRequest, UpdateFundCompanySuccessPayload, undefined>();

export const deleteClassificationTagBankRelationship = createAsyncAction(
  'fundModule/deleteClassificationTagBankRelationship/request',
  'fundModule/deleteClassificationTagBankRelationship/success',
  'fundModule/deleteClassificationTagBankRelationship/failure',
)<{ id: number }, DeleteClassificationTagBankRelationshipResponse, undefined>();

export const deleteBankFundCompanyPlatformMapping = createAsyncAction(
  'fundModule/deleteBankFundCompanyPlatformMapping/request',
  'fundModule/deleteBankFundCompanyPlatformMapping/success',
  'fundModule/deleteBankFundCompanyPlatformMapping/failure',
)<{ id: number }, DeleteBankFundCompanyPlatformMappingResponse, undefined>();
//  -------------------------------
//  User Initiator Actions
//  -------------------------------

export const getUserInitiators = createAsyncAction(
  'fundModule/getUserInitiators/request',
  'fundModule/getUserInitiators/success',
  'fundModule/getUserInitiators/failure',
)<undefined, GetUserInitiatorsSuccessPayload, undefined>();

export const createUserInitiator = createAsyncAction(
  'fundModule/createUserInitiator/request',
  'fundModule/createUserInitiator/success',
  'fundModule/createUserInitiator/failure',
)<CreateUserInitiatorRequest, CreateUserInitiatorSuccessPayload, undefined>();

export const updateUserInitiator = createAsyncAction(
  'fundModule/updateUserInitiator/request',
  'fundModule/updateUserInitiator/success',
  'fundModule/updateUserInitiator/failure',
)<UpdateUserInitiatorRequest, UpdateUserInitiatorSuccessPayload, undefined>();

export const deleteUserInitiator = createAsyncAction(
  'fundModule/deleteUserInitiator/request',
  'fundModule/deleteUserInitiator/success',
  'fundModule/deleteUserInitiator/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  User Authorization Actions
//  -------------------------------

export const getUserAuthorizations = createAsyncAction(
  'fundModule/getUserAuthorizations/request',
  'fundModule/getUserAuthorizations/success',
  'fundModule/getUserAuthorizations/failure',
)<undefined, GetUserAuthorizationsSuccessPayload, undefined>();

export const createUserAuthorization = createAsyncAction(
  'fundModule/createUserAuthorization/request',
  'fundModule/createUserAuthorization/success',
  'fundModule/createUserAuthorization/failure',
)<
  CreateUserAuthorizationRequest,
  CreateUserAuthorizationSuccessPayload,
  undefined
>();

export const updateUserAuthorization = createAsyncAction(
  'fundModule/updateUserAuthorization/request',
  'fundModule/updateUserAuthorization/success',
  'fundModule/updateUserAuthorization/failure',
)<
  UpdateUserAuthorizationRequest,
  UpdateUserAuthorizationSuccessPayload,
  undefined
>();

export const deleteUserAuthorization = createAsyncAction(
  'fundModule/deleteUserAuthorization/request',
  'fundModule/deleteUserAuthorization/success',
  'fundModule/deleteUserAuthorization/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  Fund Class Tag Email Actions
//  -------------------------------

export const getFundClassTagEmails = createAsyncAction(
  'fundModule/getFundClassTagEmails/request',
  'fundModule/getFundClassTagEmails/success',
  'fundModule/getFundClassTagEmails/failure',
)<undefined, GetFundClassTagEmailsSuccessPayload, undefined>();

export const createFundClassTagEmail = createAsyncAction(
  'fundModule/createFundClassTagEmail/request',
  'fundModule/createFundClassTagEmail/success',
  'fundModule/createFundClassTagEmail/failure',
)<
  CreateFundClassTagEmailRequest,
  CreateFundClassTagEmailSuccessPayload,
  undefined
>();

export const updateFundClassTagEmail = createAsyncAction(
  'fundModule/updateFundClassTagEmail/request',
  'fundModule/updateFundClassTagEmail/success',
  'fundModule/updateFundClassTagEmail/failure',
)<
  UpdateFundClassTagEmailRequest,
  UpdateFundClassTagEmailSuccessPayload,
  undefined
>();

export const deleteFundClassTagEmail = createAsyncAction(
  'fundModule/deleteFundClassTagEmail/request',
  'fundModule/deleteFundClassTagEmail/success',
  'fundModule/deleteFundClassTagEmail/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

export const bulkCreateFundClassTagEmails = createAsyncAction(
  'fundModule/bulkCreateFundClassTagEmails/request',
  'fundModule/bulkCreateFundClassTagEmails/success',
  'fundModule/bulkCreateFundClassTagEmails/failure',
)<
  BulkCreateFundClassTagEmailRequest,
  BulkCreateFundClassTagEmailSuccessPayload,
  undefined
>();

export const bulkDeleteFundClassTagEmails = createAsyncAction(
  'fundModule/bulkDeleteFundClassTagEmails/request',
  'fundModule/bulkDeleteFundClassTagEmails/success',
  'fundModule/bulkDeleteFundClassTagEmails/failure',
)<
  BulkDeleteFundClassTagEmailRequest,
  BulkDeleteFundClassTagEmailSuccessPayload,
  undefined
>();

export const mapEmailToMultipleTags = createAsyncAction(
  'fundModule/mapEmailToMultipleTags/request',
  'fundModule/mapEmailToMultipleTags/success',
  'fundModule/mapEmailToMultipleTags/failure',
)<
  MapEmailToMultipleTagsRequest,
  MapEmailToMultipleTagsSuccessPayload,
  undefined
>();

//  -------------------------------
//  Classification Tag Legal Entity Actions
//  -------------------------------

export const getClassificationTagLegalEntities = createAsyncAction(
  'fundModule/getClassificationTagLegalEntities/request',
  'fundModule/getClassificationTagLegalEntities/success',
  'fundModule/getClassificationTagLegalEntities/failure',
)<undefined, GetClassificationTagLegalEntitiesSuccessPayload, undefined>();

export const createClassificationTagLegalEntity = createAsyncAction(
  'fundModule/createClassificationTagLegalEntity/request',
  'fundModule/createClassificationTagLegalEntity/success',
  'fundModule/createClassificationTagLegalEntity/failure',
)<
  CreateClassificationTagLegalEntityRequest,
  CreateClassificationTagLegalEntitySuccessPayload,
  undefined
>();

export const updateClassificationTagLegalEntity = createAsyncAction(
  'fundModule/updateClassificationTagLegalEntity/request',
  'fundModule/updateClassificationTagLegalEntity/success',
  'fundModule/updateClassificationTagLegalEntity/failure',
)<
  UpdateClassificationTagLegalEntityRequest,
  UpdateClassificationTagLegalEntitySuccessPayload,
  undefined
>();

export const deleteClassificationTagLegalEntity = createAsyncAction(
  'fundModule/deleteClassificationTagLegalEntity/request',
  'fundModule/deleteClassificationTagLegalEntity/success',
  'fundModule/deleteClassificationTagLegalEntity/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  Classification Tag Deal Name Hedge Actions
//  -------------------------------

export const getClassificationTagDealNameHedges = createAsyncAction(
  'fundModule/getClassificationTagDealNameHedges/request',
  'fundModule/getClassificationTagDealNameHedges/success',
  'fundModule/getClassificationTagDealNameHedges/failure',
)<undefined, GetClassificationTagDealNameHedgesSuccessPayload, undefined>();

export const createClassificationTagDealNameHedge = createAsyncAction(
  'fundModule/createClassificationTagDealNameHedge/request',
  'fundModule/createClassificationTagDealNameHedge/success',
  'fundModule/createClassificationTagDealNameHedge/failure',
)<
  CreateClassificationTagDealNameHedgeRequest,
  CreateClassificationTagDealNameHedgeSuccessPayload,
  undefined
>();

export const updateClassificationTagDealNameHedge = createAsyncAction(
  'fundModule/updateClassificationTagDealNameHedge/request',
  'fundModule/updateClassificationTagDealNameHedge/success',
  'fundModule/updateClassificationTagDealNameHedge/failure',
)<
  UpdateClassificationTagDealNameHedgeRequest,
  UpdateClassificationTagDealNameHedgeSuccessPayload,
  undefined
>();

export const deleteClassificationTagDealNameHedge = createAsyncAction(
  'fundModule/deleteClassificationTagDealNameHedge/request',
  'fundModule/deleteClassificationTagDealNameHedge/success',
  'fundModule/deleteClassificationTagDealNameHedge/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

// Fund Level Trade Pricing Actions
export const getFundLevelTradePricings = createAsyncAction(
  'fundModule/getFundLevelTradePricings/request',
  'fundModule/getFundLevelTradePricings/success',
  'fundModule/getFundLevelTradePricings/failure',
)<undefined, GetFundLevelTradePricingsSuccessPayload, undefined>();

export const createFundLevelTradePricing = createAsyncAction(
  'fundModule/createFundLevelTradePricing/request',
  'fundModule/createFundLevelTradePricing/success',
  'fundModule/createFundLevelTradePricing/failure',
)<
  CreateFundLevelTradePricingRequest,
  CreateFundLevelTradePricingSuccessPayload,
  undefined
>();

export const updateFundLevelTradePricing = createAsyncAction(
  'fundModule/updateFundLevelTradePricing/request',
  'fundModule/updateFundLevelTradePricing/success',
  'fundModule/updateFundLevelTradePricing/failure',
)<
  UpdateFundLevelTradePricingRequest,
  UpdateFundLevelTradePricingSuccessPayload,
  undefined
>();

export const deleteFundLevelTradePricing = createAsyncAction(
  'fundModule/deleteFundLevelTradePricing/request',
  'fundModule/deleteFundLevelTradePricing/success',
  'fundModule/deleteFundLevelTradePricing/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

export const getAllUsers = createAsyncAction(
  'fundModule/getAllUsers/request',
  'fundModule/getAllUsers/success',
  'fundModule/getAllUsers/failure',
)<undefined, GetAllUsersSuccessPayload, undefined>();

// --------------------------
// Workflow Filtering
// --------------------------

export const getWorkflowCompanyFilters = createAsyncAction(
  'fundModule/getWorkflowCompanyFilters/request',
  'fundModule/getWorkflowCompanyFilters/success',
  'fundModule/getWorkflowCompanyFilters/failure',
)<undefined, GetWorkflowComapnyFiltersResponse, undefined>();

export const createWorkflowCompanyFilters = createAsyncAction(
  'fundModule/createWorkflowCompanyFilters/request',
  'fundModule/createWorkflowCompanyFilters/success',
  'fundModule/createWorkflowCompanyFilters/failure',
)<
  CreateWorkflowFilteringPayload,
  GetWorkflowComapnyFiltersResponse,
  undefined
>();

export const updateWorkflowCompanyFilters = createAsyncAction(
  'fundModule/updateWorkflowCompanyFilters/request',
  'fundModule/updateWorkflowCompanyFilters/success',
  'fundModule/updateWorkflowCompanyFilters/failure',
)<
  CreateWorkflowFilteringPayload,
  GetWorkflowComapnyFiltersResponse,
  undefined
>();

//  -------------------------------
//  Bid Criteria Actions
//  -------------------------------

export const getBidCriteria = createAsyncAction(
  'fundModule/getBidCriteria/request',
  'fundModule/getBidCriteria/success',
  'fundModule/getBidCriteria/failure',
)<undefined, GetBidCriteriaSuccessPayload, undefined>();

export const createBidCriteria = createAsyncAction(
  'fundModule/createBidCriteria/request',
  'fundModule/createBidCriteria/success',
  'fundModule/createBidCriteria/failure',
)<CreateBidCriteriaRequest, CreateBidCriteriaSuccessPayload, undefined>();

export const updateBidCriteria = createAsyncAction(
  'fundModule/updateBidCriteria/request',
  'fundModule/updateBidCriteria/success',
  'fundModule/updateBidCriteria/failure',
)<UpdateBidCriteriaRequest, UpdateBidCriteriaSuccessPayload, undefined>();

export const deleteBidCriteria = createAsyncAction(
  'fundModule/deleteBidCriteria/request',
  'fundModule/deleteBidCriteria/success',
  'fundModule/deleteBidCriteria/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  Execution Ledger Actions
//  -------------------------------

export const getExecutionLedger = createAsyncAction(
  'fundModule/getExecutionLedger/request',
  'fundModule/getExecutionLedger/success',
  'fundModule/getExecutionLedger/failure',
)<undefined, GetExecutionLedgerSuccessPayload, undefined>();

export const createExecutionLedger = createAsyncAction(
  'fundModule/createExecutionLedger/request',
  'fundModule/createExecutionLedger/success',
  'fundModule/createExecutionLedger/failure',
)<CreateExecutionLedgerRequest, CreateExecutionLedgerSuccessPayload, undefined>();

export const updateExecutionLedger = createAsyncAction(
  'fundModule/updateExecutionLedger/request',
  'fundModule/updateExecutionLedger/success',
  'fundModule/updateExecutionLedger/failure',
)<UpdateExecutionLedgerRequest, UpdateExecutionLedgerSuccessPayload, undefined>();

export const deleteExecutionLedger = createAsyncAction(
  'fundModule/deleteExecutionLedger/request',
  'fundModule/deleteExecutionLedger/success',
  'fundModule/deleteExecutionLedger/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  FIX Session Actions
//  -------------------------------

export const getFixSessions = createAsyncAction(
  'fundModule/getFixSessions/request',
  'fundModule/getFixSessions/success',
  'fundModule/getFixSessions/failure',
)<undefined, GetFixSessionsSuccessPayload, undefined>();

export const createFixSession = createAsyncAction(
  'fundModule/createFixSession/request',
  'fundModule/createFixSession/success',
  'fundModule/createFixSession/failure',
)<CreateFixSessionRequest, CreateFixSessionSuccessPayload, undefined>();

export const updateFixSession = createAsyncAction(
  'fundModule/updateFixSession/request',
  'fundModule/updateFixSession/success',
  'fundModule/updateFixSession/failure',
)<UpdateFixSessionRequest, UpdateFixSessionSuccessPayload, undefined>();

export const deleteFixSession = createAsyncAction(
  'fundModule/deleteFixSession/request',
  'fundModule/deleteFixSession/success',
  'fundModule/deleteFixSession/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  FIX Reference Actions
//  -------------------------------

export const getFixReferences = createAsyncAction(
  'fundModule/getFixReferences/request',
  'fundModule/getFixReferences/success',
  'fundModule/getFixReferences/failure',
)<undefined, GetFixReferencesSuccessPayload, undefined>();

export const createFixReference = createAsyncAction(
  'fundModule/createFixReference/request',
  'fundModule/createFixReference/success',
  'fundModule/createFixReference/failure',
)<CreateFixReferenceRequest, CreateFixReferenceSuccessPayload, undefined>();

export const updateFixReference = createAsyncAction(
  'fundModule/updateFixReference/request',
  'fundModule/updateFixReference/success',
  'fundModule/updateFixReference/failure',
)<UpdateFixReferenceRequest, UpdateFixReferenceSuccessPayload, undefined>();

export const deleteFixReference = createAsyncAction(
  'fundModule/deleteFixReference/request',
  'fundModule/deleteFixReference/success',
  'fundModule/deleteFixReference/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

//  -------------------------------
//  Trade Request Email Recipient Actions
//  -------------------------------

export const getTradeRequestEmailRecipients = createAsyncAction(
  'fundModule/getTradeRequestEmailRecipients/request',
  'fundModule/getTradeRequestEmailRecipients/success',
  'fundModule/getTradeRequestEmailRecipients/failure',
)<undefined, GetTradeRequestEmailRecipientsSuccessPayload, undefined>();

export const createTradeRequestEmailRecipient = createAsyncAction(
  'fundModule/createTradeRequestEmailRecipient/request',
  'fundModule/createTradeRequestEmailRecipient/success',
  'fundModule/createTradeRequestEmailRecipient/failure',
)<
  CreateTradeRequestEmailRecipientRequest,
  CreateTradeRequestEmailRecipientSuccessPayload,
  undefined
>();

export const updateTradeRequestEmailRecipient = createAsyncAction(
  'fundModule/updateTradeRequestEmailRecipient/request',
  'fundModule/updateTradeRequestEmailRecipient/success',
  'fundModule/updateTradeRequestEmailRecipient/failure',
)<
  UpdateTradeRequestEmailRecipientRequest,
  UpdateTradeRequestEmailRecipientSuccessPayload,
  undefined
>();

export const deleteTradeRequestEmailRecipient = createAsyncAction(
  'fundModule/deleteTradeRequestEmailRecipient/request',
  'fundModule/deleteTradeRequestEmailRecipient/success',
  'fundModule/deleteTradeRequestEmailRecipient/failure',
)<{ id: number }, { id: number; message: string }, undefined>();

export const bulkCreateTradeRequestEmailRecipients = createAsyncAction(
  'fundModule/bulkCreateTradeRequestEmailRecipients/request',
  'fundModule/bulkCreateTradeRequestEmailRecipients/success',
  'fundModule/bulkCreateTradeRequestEmailRecipients/failure',
)<
  BulkCreateTradeRequestEmailRecipientRequest,
  BulkCreateTradeRequestEmailRecipientSuccessPayload,
  undefined
>();

export const bulkDeleteTradeRequestEmailRecipients = createAsyncAction(
  'fundModule/bulkDeleteTradeRequestEmailRecipients/request',
  'fundModule/bulkDeleteTradeRequestEmailRecipients/success',
  'fundModule/bulkDeleteTradeRequestEmailRecipients/failure',
)<
  BulkDeleteTradeRequestEmailRecipientRequest,
  BulkDeleteTradeRequestEmailRecipientSuccessPayload,
  undefined
>();
